export const SLICE_NAME = {
  RECIPE_DATA:'RECIPE_DATA',
  PRODUCT_DATA:'PRODUCT_DATA',
}

 